import React from 'react';
import Contact from './Contact/Contact';


import './Home.css';
import Inventory from './Inventory/Inventory';
import Review from './Review/Review';
import Stocks from './Stocks/Stocks';

const Home = () => {
	/* const [user, loading] = useAuthState(auth);
	if (loading) {
		return <Loading></Loading>
	} */
	return (
		<section>

			{/* End of the navbar  */}
			<div className="banner">
				<div className="banner-container-info">
					<article className="banner-info">
						<h3> Bangladesh is a beautiful country. Various kinds of fruits grow in Bangladesh.</h3>
						<p>
							Among them, mango, orange, pineapple, banana, Lychee, coconut, lemons, pummel, guavas etc. are the main fruits of Bangladesh.
						</p>
					</article>
				</div>
			</div>
			{/* end of the banner sections  */}

			<Inventory></Inventory>
			{/* end of inventory section */}
			<Stocks></Stocks>
			<Review></Review>
		










			{/* <h3> Total Users : {users.length} </h3>
			{
				users.map(user => <li
					key={user._id}
				> {user.name}  and  {user.email}
					<Link to={`/update/${user._id}`}><button> Update </button></Link>
					<button onClick={() => handledeleteUser(user._id)}>X</button>
				</li>)
			} */}
		</section>
	);
};

export default Home;